/* Generate a data-auto attribute for automation */
export const generateDataAuto = (key: string, name: string) => {
  return name != null && typeof name.toLowerCase === 'function'
    ? `${key}_${name
        .toLowerCase()
        .replace(/&nbsp;/g, '')
        .replace(/\u00A0/g, '')
        .replace(/ /g, '_')}`
    : '';
};
